
export const apiCall = function(uri,type,data){
	if(type == 'POST'){
		return fetch(uri,{
			method: type,
			body: JSON.stringify(data)
		});
	}

	return fetch(uri,{method: type});
}